module.exports = __webpack_public_path__ + "img/journey phone mockup.4f796c8a.png";